var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"k-header navbar container-fluid",class:{"logged": _vm.user.idusuario}},[_c('section',{staticClass:"header-nav"},[_vm._m(0),_vm._t("header")],2),_c('section',{staticClass:"lateral-nav box-menu-mobile",class:_vm.classDynamic},[_vm._t("lateralMobile")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"navbar-brand"},[_c('img',{attrs:{"src":require("@/assets/images/logo-h.png")}})])
}]

export { render, staticRenderFns }